import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { copy } from '@shared/utils/common.util';
import { CommonService } from '@src/app/services/common.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { FollowAddressItem } from '@src/app/shared/types/address.type';
import { Collection } from '@src/app/shared/types/contract.type';
import { FollowBtnComponent } from '../follow-btn/follow-btn.component';

@Component({
    selector: 'app-user-card',
    standalone: true,
    imports: [CommonModule, SharedModule, FollowBtnComponent],
    templateUrl: './user-card.component.html',
    styleUrls: ['./user-card.component.less'],
})
export class UserCardComponent {
    @Input() userInfo: FollowAddressItem & { collections?: Collection[] };
    @Input() gradientCard = false;

    constructor(public walletStatusService: WalletStatusService, public commonService: CommonService) {}

    copy(str: string) {
        copy(str).then(() => this.commonService.success('Copied!'));
    }
}
